import React from "react";
import {branchedComponent} from "../utils/branch";
import {StoTerms} from "./stoTerms";
import {NyTerms} from "./nyTerms";

export const Terms = branchedComponent({stockholm: StoTerms, new_york: NyTerms});